import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { Link } from 'gatsby';
import React, { FC, useContext, useState } from 'react';
import styled from 'styled-components';
import { scrollToBottom } from '../utils/ScrollToBottom';
import GlobalContext from './GlobalContext';
import { Logo } from './Logo';

interface NavProps {
  chapters: Array<any>;
  chapterRefs: Array<any>;
  mainRef: any;
  globalState: any;
  setGlobalState: any;
  activeChapter: any;
}

export const Nav: FC<NavProps> = ({ chapters, chapterRefs, mainRef }) => {
  const [open, setOpen] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState('');
  const [globalState, setGlobalState] = useContext(GlobalContext);

  const { scrollY } = globalState;

  const scrollToView: any = (
    chapter: { current: Element },
    activeChapter: number,
    mobile?: boolean
  ): any => {
    chapter.current?.scrollIntoView({ behavior: 'smooth' });
    setGlobalState({ ...globalState, activeChapter });
    if (mobile) toggleMenu();
  };

  const toggleMenu = () => {
    setOpen(!open);
  };

  // const scrolling = () => {
  //   setOpen(false);
  // };

  // useEffect(() => {
  // document.addEventListener('scroll', scrolling);

  // const [chapterNumber, sectionNumber] = window.location.href
  //   .slice(-3)
  //   .split('/');

  // console.log(
  //   '....chapternumber',
  //   { chapters },
  //   { chapterNumber },
  //   { sectionNumber }
  // );
  //   if (chapterNumber && sectionNumber)
  //     scrollToView(chapterRefs[chapterNumber], chapters[chapterNumber]);
  // }, []);
  // console.log(
  //   { activeChapter },
  //   'This should be the loaded madafuckah, if url is url/1/1'
  // );

  // const chapterRefsScrollPosition = (el: any) => {
  //   return el.current.offsetTop
  // };

  useScrollPosition(({ prevPos, currPos }) => {
    setGlobalState({ ...globalState, scrollY: currPos.y });
    highLightMenuOnScroll();
  });

  const highLightMenuOnScroll = () => {
    const foundChapter = chapterRefs.findIndex((ref: any, i: number) => {
      const currentItem = ref.current.offsetTop;
      const nextItem = chapterRefs[i + 1]
        ? chapterRefs[i + 1].current.offsetTop
        : 100000;

      //Adding -5 to trigger chapterchange a bit before landing on the chapter
      return (
        (Math.abs(scrollY - 5) > currentItem &&
          Math.abs(scrollY - 5) < nextItem) ||
        Math.abs(scrollY) === currentItem
      );
    });

    if (foundChapter === -1) foundChapter;
    if (foundChapter < 0) {
      setActiveMenuItem('');
      return;
    }

    setActiveMenuItem(chapters[foundChapter].node.id);
  };

  return (
    <StyledNav>
      <ul>
        <li className="logo-li">
          <Logo
            title={globalState.mainData.title}
            toggleMenu={toggleMenu}
            scrollTo={() => scrollToView(mainRef, globalState.mainData)}
          />
        </li>

        {/* {open && ( */}
        <OpenHamburger open={open}>
          <div className="close-cross" onClick={toggleMenu}></div>
          <nav className="hamburger-nav">
            <h1> {globalState.mainData.title} </h1>
            <ul>
              {chapters.map((chapter: any, i: number) => {
                return (
                  <li
                    key={i}
                    onClick={() => scrollToView(chapterRefs[i], chapter, true)}
                    className="hamburger-menu-item"
                  >
                    <Link
                      to={`/${chapter.node.slug.current}/`}
                      onClick={(evt) => evt.preventDefault()}
                    >
                      {chapter.node.slug.current}
                    </Link>
                  </li>
                );
              })}
              <li
                className="hamburger-menu-item"
                onClick={() => scrollToBottom()}
              >
                ENDNOTES
              </li>
            </ul>
          </nav>
        </OpenHamburger>
        {/* )} */}
        <div className="menu-desktop-container">
          {chapters.map((chapter: any, i: number) => {
            const active = chapter.node.id === activeMenuItem;
            return (
              <li
                key={i}
                onClick={() => scrollToView(chapterRefs[i], chapter)}
                className="menu-item"
              >
                <div className={active ? 'border active' : 'border'}> </div>
                <Link
                  to={`/${chapter.node.slug.current}/`}
                  onClick={(evt) => evt.preventDefault()}
                >
                  {chapter.node.slug.current}
                </Link>
                <div> </div>
              </li>
            );
          })}
        </div>
      </ul>
    </StyledNav>
  );
};

const OpenHamburger = styled.div<any>`
  height: 100vh;
  z-index: 9999;
  background-color: var(--red);
  width: ${(p) => (p.open ? 100 : 0)}%;
  transition: 1s;
  position: fixed;
  top: 0;
  left: 0;
  white-space: nowrap;

  .hamburger-nav {
    margin-top: 100px;
    overflow: hidden;
  }

  .close-cross {
    position: absolute;
    right: 16px;
    top: 16px;
    width: 32px;
    height: 32px;
    opacity: 0.8;
  }
  .close-cross:hover {
    opacity: 1;
  }
  .close-cross:before,
  .close-cross:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 40px;
    width: 1px;
    background-color: var(--white);
  }
  .close-cross:before {
    transform: rotate(45deg);
  }
  .close-cross:after {
    transform: rotate(-45deg);
  }

  h1 {
    color: var(--white);
    margin-bottom: 35px;
    font-size: 1.5em;
  }

  .hamburger-menu-item {
    min-width: 100%;
    font-size: 1.4em;
    padding: 10px 0;
    text-transform: uppercase;
    letter-spacing: 0.15em;
    color: var(--lightgrey);
    a {
      color: var(--lightgrey);
    }
  }
`;

const StyledNav = styled.nav<any>`
  background: var(--white);
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  height: 65px;
  position: fixed;
  z-index: 999;
  .logo-li {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    @media (max-width: 1400px) {
      width: 100%;
    }
  }

  ul {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
    text-align: center;
    list-style: none;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    @media (max-width: 1400px) {
      justify-content: space-between;
    }

    .menu-desktop-container {
      flex: 1;
      display: flex;
      height: 100%;
      @media (max-width: 1100px) {
        display: none;
      }
    }

    .menu-item {
      display: flex;
      height: 100%;
      padding: 0;
      justify-content: space-between;
      flex: 1;
      font-weight: bold;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 0.8em;
      letter-spacing: 0.4em;
      margin: 0 5px;

      a {
        white-space: nowrap;
      }

      .border {
        width: 100%;
        height: 7px;
        transition: all 250ms ease-in-out;
      }

      @media (max-width: 500px) {
        font-size: 0.5rem;
      }
      color: var(--darkestgrey);
    }
  }
  .active {
    background-color: var(--red);
  }
`;
